import { Account } from "model/account";
import { Exhibition } from "model/exhibition";
import { Rodeo } from "../model/rodeo";
import { RodeoEventRegistration } from "model/rodeoEventRegistration";

export class EntryCostGenerator {
    private static _instance: EntryCostGenerator;

    combinedRegistrations: any[];
    rodeoEventMap: any[];
    sidepotMap: any[];
    exhibitionMap: any[];
    contestantTotalFee: any[];
    contestantOfficeFeeTotal: any[];

    private constructor() { }

    static instance(): EntryCostGenerator {
        if (this._instance == undefined)
            this._instance = new this();

        return this._instance;
    }

    reloadEntryInfo(rodeo, searchName) {
        this.rodeoEventMap = [];
        this.sidepotMap = [];
        this.contestantTotalFee = [];
        this.exhibitionMap = [];
        this.contestantOfficeFeeTotal = [];

        rodeo.rodeoEvents.forEach((rodeoEvent) => {
            this.rodeoEventMap[rodeoEvent.id] = rodeoEvent;

            rodeoEvent.sidepots.forEach((sidepot) => {
                this.sidepotMap[sidepot.id] = sidepot;
            })
        });

        rodeo.exhibitions.forEach((exhibition) => {
            this.exhibitionMap[exhibition.id] = exhibition;
        })

        this.buildCombinedRegistrations(rodeo, searchName);
    }

    getCombinedRegistrations() {
        return this.combinedRegistrations;
    }

    getContestantOfficeFeeTotal(contestantId) {
        return this.contestantOfficeFeeTotal[contestantId]; 
    }

    getContestantTotalFee(contestantId) {
        return this.contestantTotalFee[contestantId]; 
    }

    private buildCombinedRegistrations(rodeo : Rodeo, searchName) {
        this.combinedRegistrations = [];
        let registrationMap = new Map<number, any>();
        const allRegistrations = rodeo.rodeoEvents.flatMap(x => x.registrations);
        let registrations = allRegistrations;
        let validMembershipIds = rodeo.organization.memberships.filter(x => x.isPermit == false).map(x => x.id);

        if (searchName) {
            registrations = [];

            var firstName = searchName.split(' ')[0];
            var lastName = searchName.split(' ')[1];
            if (firstName && !lastName) {
                registrations.push(...allRegistrations.filter(x =>
                    (
                        x.contestantOne.firstName.toLowerCase().includes(firstName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                    )
                    || (
                        x.contestantOne.lastName.toLowerCase().includes(firstName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                    )));
            } else {
                registrations.push(...allRegistrations.filter(x =>
                    (
                        x.contestantOne.firstName.toLowerCase().includes(firstName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                    )
                    && (
                        x.contestantOne.lastName.toLowerCase().includes(lastName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().includes(lastName.toLocaleLowerCase()))
                    )));
            }
            
            registrations.push(...allRegistrations.filter(x => 
                x.horseOne && x.horseOne.name.toLowerCase().includes(searchName.toLowerCase())
                || x.horseTwo && x.horseTwo.name.toLowerCase().includes(searchName.toLowerCase())));
        }

        registrations = [...new Set(registrations)];

        for (let registration of registrations) {
            if (!registrationMap.has(registration.contestantOne.id)) {
                registrationMap.set(registration.contestantOne.id, { registrations: [] });
                this.contestantOfficeFeeTotal[registration.contestantOne.id] = 0;
                this.contestantTotalFee[registration.contestantOne.id] = 0;
            }

            if (registrationMap.get(registration.contestantOne.id).registrations.indexOf(registration) == -1)
                registrationMap.get(registration.contestantOne.id).registrations.push(registration);

            if (registration.contestantTwo != null) {
                if (!registrationMap.has(registration.contestantTwo.id)) {
                    registrationMap.set(registration.contestantTwo.id, { registrations: [] });
                    this.contestantOfficeFeeTotal[registration.contestantTwo.id] = 0;
                    this.contestantTotalFee[registration.contestantTwo.id] = 0;
                }

                if (registrationMap.get(registration.contestantTwo.id).registrations.indexOf(registration) == -1)
                    registrationMap.get(registration.contestantTwo.id).registrations.push(registration);

                this.contestantTotalFee[registration.contestantOne.id] += this.rodeoEventMap[registration.rodeoEventId].entryCost / 2;
                this.contestantTotalFee[registration.contestantTwo.id] += this.rodeoEventMap[registration.rodeoEventId].entryCost / 2;
            } else if (registration.isDraw)
                this.contestantTotalFee[registration.contestantOne.id] += this.rodeoEventMap[registration.rodeoEventId].entryCost / 2;
            else {
                this.contestantTotalFee[registration.contestantOne.id] += this.rodeoEventMap[registration.rodeoEventId].entryCost;
            }

            registration.carryOvers.forEach(carryOver => {
                if (registration.contestantTwo != null) {
                    this.contestantTotalFee[registration.contestantOne.id] += this.rodeoEventMap[carryOver.rodeoEventId].entryCost / 2;
                    this.contestantTotalFee[registration.contestantTwo.id] += this.rodeoEventMap[carryOver.rodeoEventId].entryCost / 2;
                } else if (registration.isDraw)
                    this.contestantTotalFee[registration.contestantOne.id] += this.rodeoEventMap[carryOver.rodeoEventId].entryCost / 2;
                else {
                    this.contestantTotalFee[registration.contestantOne.id] += this.rodeoEventMap[carryOver.rodeoEventId].entryCost;
                }
            });

            registration.sidepotIds.forEach(sidepotId => {
                this.contestantTotalFee[registration.contestantOne.id] += this.sidepotMap[sidepotId].cost;
            });

            if (new Date(registration.created) > new Date(rodeo.lateRegistrationStartDate)) {
                (registration as any).late = true;
            }
        }

        this.combinedRegistrations = Array.from(registrationMap.values());

        registrationMap.forEach((contestantRegObject, contestantId) => {
            let officeFeePerUniqueEntry = false;
            let contestantRegistrations = contestantRegObject.registrations;

            if (officeFeePerUniqueEntry) {
                this.contestantOfficeFeeTotal[contestantId] = contestantRegistrations.filter(x => this.rodeoEventMap[x.rodeoEventId].entryCost > 0).length * rodeo.officeFee;
            } else {
                this.contestantOfficeFeeTotal[contestantId] = rodeo.officeFee;
            }

            this.contestantTotalFee[contestantId] += this.contestantOfficeFeeTotal[contestantId];

            contestantRegObject.exhibitions = [];
            contestantRegistrations.forEach((registration) => {
                if (registration.late) 
                    contestantRegObject.late = true;
                
                registration.exhibitions.forEach((regExhibition) => {
                    var exhibition = this.exhibitionMap[regExhibition.exhibitionId];
                    
                    var matchingExhibition = contestantRegObject.exhibitions.filter(x => 
                        x.cost == exhibition.cost 
                        && x.bulkThreshold == exhibition.bulkThreshold
                        && x.bulkCost == exhibition.bulkCost)[0];

                    if (!matchingExhibition) {
                        let exhibitionRecord: any = {};
                        exhibitionRecord.cost = exhibition.cost;
                        exhibitionRecord.bulkThreshold = exhibition.bulkThreshold;
                        exhibitionRecord.bulkCost = exhibition.bulkCost;
                        exhibitionRecord.bulkCount = 0;
                        exhibitionRecord.singles = 0;
                        
                        contestantRegObject.exhibitions.push(exhibitionRecord);
                        matchingExhibition = exhibitionRecord;
                    }
                    
                    matchingExhibition.bulkCount += Math.floor((matchingExhibition.singles + regExhibition.entryCount) / matchingExhibition.bulkThreshold);
                    matchingExhibition.singles = Math.floor((matchingExhibition.singles + regExhibition.entryCount) % matchingExhibition.bulkThreshold);
                });
            })

            if (contestantRegObject.late)
                this.contestantTotalFee[contestantId] += rodeo.lateFee;
                
            contestantRegObject.exhibitionBulkCount = 0;
            contestantRegObject.exhibitionSingleCount = 0;
            contestantRegObject.exhibitionBulkCost = 0;
            contestantRegObject.exhibitionSingleCost = 0;            

            contestantRegObject.exhibitions.forEach((matchingExhibition) => {
                this.contestantTotalFee[contestantId] += matchingExhibition.bulkCount * matchingExhibition.bulkCost;
                this.contestantTotalFee[contestantId] += matchingExhibition.singles * matchingExhibition.cost;
                contestantRegObject.exhibitionBulkCount += matchingExhibition.bulkCount;
                contestantRegObject.exhibitionSingleCount += matchingExhibition.singles;
                contestantRegObject.exhibitionBulkCost += matchingExhibition.bulkCount * matchingExhibition.bulkCost;
                contestantRegObject.exhibitionSingleCost += matchingExhibition.singles * matchingExhibition.cost;
            });

            contestantRegObject.contestant = contestantRegObject.registrations[0].contestantOneId == contestantId ? contestantRegObject.registrations[0].contestantOne : contestantRegObject.registrations[0].contestantTwo;
            contestantRegObject.membershipStatus = contestantRegObject.contestant.memberships.some(x => x.isExpired == false && validMembershipIds.some(y => y == x.membershipId)) ? 'MEMBER' : 'NON-MEMBER';
        });

        this.combinedRegistrations.sort((a, b) => {
            if (a.contestant.lastName.trim().toLocaleLowerCase() < b.contestant.lastName.trim().toLocaleLowerCase())
                return -1;

            if (a.contestant.lastName.trim().toLocaleLowerCase() > b.contestant.lastName.trim().toLocaleLowerCase())
                return 1;

            if (a.contestant.firstName.trim().toLocaleLowerCase() < b.contestant.firstName.trim().toLocaleLowerCase())
                return -1;

            if (a.contestant.firstName.trim().toLocaleLowerCase() > b.contestant.firstName.trim().toLocaleLowerCase())
                return 1;

            return 0;
        });
    }
}


// WEBPACK FOOTER //
// ./src/lib/entryCostGenerator.ts